import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const CustomInput = forwardRef(({ value, onChange, disabled, placeholder }, ref) => (
  <input
    ref={ref}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    disabled={disabled}
    className="sm:px-6 sm:py-3 px-4 py-2 h-auto w-full bg-gray-500 bg-opacity-5 placeholder-gray-700 focus:outline-none"
  />
));

CustomInput.displayName = 'CustomInput';

CustomInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CustomInput.defaultProps = {
  placeholder: 'Enter a phone number',
  disabled: false,
};

export default CustomInput;
